import { render, staticRenderFns } from "./table-v1-minimal.vue?vue&type=template&id=6e160445&"
import script from "./table-v1-minimal.vue?vue&type=script&lang=js&"
export * from "./table-v1-minimal.vue?vue&type=script&lang=js&"
import style0 from "./table-v1-minimal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports